export default "__VITE_ASSET__C_QJ7rd5__"